module.exports = __webpack_public_path__ + "static/media/crop-squares.f474261d.png";